/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { ProductComponent } from '@msdyn365-commerce/components';
import { ICoreContext, IImageSettings, ITelemetry } from '@msdyn365-commerce/core';
import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { IMandsSearchResultContainerResources } from '../mands-search-result-container.props.autogenerated';

interface IProductSearchResultItems {
    products: ProductSearchResult[];
    context: ICoreContext;
    resources: IMandsSearchResultContainerResources;
    telemetry: ITelemetry;
    imageSettings?: IImageSettings;
    moduleType: string;
    moduleId: string;
    productComparisonButton?: {} | null | undefined;
}

export const ProductSearchResultItems: React.FC<IProductSearchResultItems> = ({
    products,
    context,
    imageSettings,
    resources,
    moduleType,
    moduleId,
    productComparisonButton
}) => {
    return (
        <ul className='list-unstyled'>
            {products.map((product: ProductSearchResult, index: number) => (
                <li className='ms-product-search-result__item' key={index}>
                    <ProductComponent
                        context={context}
                        imageSettings={imageSettings}
                        freePriceText={resources.priceFree}
                        originalPriceText={resources.originalPriceText}
                        currentPriceText={resources.currentPriceText}
                        ratingAriaLabel={resources.ratingAriaLabel}
                        id={moduleId}
                        typeName={moduleType}
                        data={{ product: product }}
                        productComparisonButton={productComparisonButton}
                    />
                </li>
            ))}
        </ul>
    );
};
